export default __webpack_public_path__ + "static/media/celcom_logo.f6d247b9.svg";